import React from "react";
import PropTypes from "prop-types";
import Header from "./header";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";
import { useChatCurrentUser } from "../contexts/chat-current-user-context";
import { Layout, Button, Icon, LinkButton } from "@evertrue/et-components";
import { useChatNavigationContext } from "../contexts/chat-navigation-context";
import MemberList from "./member-list";
import { isDM } from "../utils/utils";

const ChatRoomSettings = ({ roomId, currentRoom, roomName }) => {
  const [, dispatch] = useChatNavigationContext();
  const { mixPanelEvents } = useChatDependencyContext();
  const { currentChatUser } = useChatCurrentUser();

  const handleLeave = () => {
    dispatch({ type: "UPDATE_LEFT_ROOM_MESSAGE", payload: roomName });

    currentChatUser
      .leaveRoom({ roomId: currentRoom.id })
      .then(room => {
        if (!isDM(room.name)) {
          mixPanelEvents.leavePoolChat();
        }
        dispatch({ type: "HOME" });
        setTimeout(() => {
          dispatch({ type: "UPDATE_LEFT_ROOM_MESSAGE", payload: null });
        }, 3000);
      })
      .catch(err => {
        console.log(`Error leaving room ${currentRoom.id}: ${err}`);
      });
  };

  return (
    <div className="chatroom-settings">
      <Layout
        header={
          <Header
            title="Chatroom Setting"
            showClose
            showBack
            onBack={() => dispatch({ type: "SELECT_ROOM", payload: roomId })}
          />
        }
      >
        <div className="chatroom-settings--info">
          <div className="chatroom-settings--title">{roomName}</div>
          <Button type="destroy" onClick={handleLeave} className="chatroom-settings--leave">
            Leave
          </Button>
        </div>

        <div className="chatroom-settings--sub-header">
          Moderation
          <LinkButton title="evertrue help page" href="https://help.evertrue.com/" target="_blank">
            <Icon icon="help" className="chatroom-settings--moderation-icon" />
          </LinkButton>
        </div>
        <div className="chatroom-settings--moderation">
          To request a removal of a message, contact Genius@evertrue.com with a message ID located on the bottom of each
          message or simply attach a screen shot
        </div>

        <div className="chatroom-settings--sub-header">{`Members (${currentRoom.users.length})`}</div>
        <MemberList currentRoom={currentRoom} currentChatUser={currentChatUser} />
      </Layout>
    </div>
  );
};

ChatRoomSettings.propTypes = {
  currentRoom: PropTypes.object.isRequired,
  roomId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  roomName: PropTypes.string.isRequired,
};

export default ChatRoomSettings;
